
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.23 11.528c.24.07.477-.068.554-.334L9.657 1.147c.072-.266-.048-.511-.29-.585-.24-.069-.476.069-.553.334L5.946 10.944c-.072.265.043.51.284.584zm4.784-1.782l3.619-3.335a.483.483 0 000-.731l-3.62-3.335c-.197-.192-.47-.187-.64.005-.168.191-.139.466.054.648l3.301 3.045-3.301 3.05c-.193.181-.222.456-.053.648.168.191.442.191.64.005zm-6.43.005c.202.186.472.181.64-.01.169-.192.145-.462-.048-.643l-3.301-3.05 3.301-3.05c.193-.182.217-.452.048-.648-.168-.192-.438-.192-.64-.005L.965 5.68a.49.49 0 000 .731l3.62 3.34z","fill":"currentColor"}})])
          )
        }
      }
    